export enum StorageKind {
  Ingest = "Ingest",
  Stagging = "Stagging",
  StandardAndWork = "StandardAndWork",
  Generated = "Generated",
  Outgoing = "Outgoing",
  ProxyTag = "ProxyTag",
  ProxyOrLowResolution = "ProxyOrLowResolution",
  Archive = "Archive",
  Backup = "Backup",
  Trash = "Trash",
  MiscOrMetadata = "MiscOrMetadata",
  WorkingArea = "WorkingArea",
  External = "External",
  LegacyImporter = "LegacyImporter",
  BulkMetadataImporter = "BulkMetadataImporter",
}
